<template>
  <div class="main">
    <div v-for="(item, index) in dataList" :key="index">
      <h5 class="m-0 text-bold">รอบสร้างบิล / แบทช์บริษัท {{ item.name }}</h5>
      <span class="text-description">
        ระบบจะสร้างบิล / แบทช์ทุกๆ (จะต้องกรอกตัวเลขที่หารด้วย 5 ลงตัวเสมอ)
      </span>
      <p class="m-0 text-description text-red">
        รอบต่อไป {{ $moment(item.nextBatchTime).format("HH:mm") }}
      </p>
      <div class="input">
        <InputText
          v-model="item.createdTimeBatch"
          class="input-text"
          placeholder="กรุณากรอกนาที"
          textFloat=""
          type="number"
          name="metatitle"
          isRequired
          textMinValue="5"
        />
      </div>
      <p class="text-error mb-2" v-if="item.error">
        {{ item.error.status == true ? item.error.text : "" }}
      </p>
    </div>
    <div class="footer">
      <b-button class="btn-cancel" @click="cancel">ย้อนกลับ</b-button>
      <b-button class="btn-save" @click="isCheck">บันทึก</b-button>
    </div>
  </div>
</template>

<script>
import InputText from "@/components/inputs/InputText";

export default {
  components: {
    InputText,
  },
  data() {
    return {
      dataList: [],
      error: false,
    };
  },
  mounted() {
    this.getListCreateTimeBatch();
  },
  methods: {
    getListCreateTimeBatch() {
      this.axios
        .get(`${this.$baseUrl}/Batch/ListCreatedTimeBatch`)
        .then((result) => {
          if (result.result == 1) {
            this.dataList = result.detail.map((x) => {
              return {
                ...x,

                // add state error for render only and then when send to api this error will remove
                error: {
                  text: "",
                  status: false,
                },
              };
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    isCheck() {
      this.dataList.forEach((x) => {
        if (!x.createdTimeBatch) {
          x.error.status = true;
          x.error.text = "กรุณากรอกข้อมูล";
        } else if (x.createdTimeBatch < 5) {
          x.error.status = true;
          x.error.text = "กรุณากรอกตัวเลขมากกว่า 5";
        } else if (x.createdTimeBatch % 5 != 0) {
          x.error.status = true;
          x.error.text = "กรุณากรอกตัวเลขที่หารด้วย 5 ลงตัว";
        } else {
          x.error.status = false;
          x.error.text = "";
        }
      });

      let condition = this.dataList.every((x) => x.error.status == false);

      if (condition) {
        this.submitCreatedTimeBatch();
      }
    },
    submitCreatedTimeBatch() {
      // clone ไว้เพื่อให้ตอนโหลดข้อมูลหน้าเว้ปไม่หาย แต่ข้อมูลจริงๆหายไปแล้ว
      let cloneArr = [...this.dataList];

      let finalData = cloneArr.map((x) => {
        delete x.error;
        delete x.name;
        return {
          ...x,
        };
      });

      let body = {
        ListCreatedTimeDetail: finalData,
      };

      this.axios
        .post(`${this.$baseUrl}/Batch/SubmitCreatedTimeBatch`, body)
        .then((result) => {
          if (result.result == 1) {
            this.cancel();

            // modal import in main pages
            this.$bvModal.show("modal-text");
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    cancel() {
      this.$emit("cancel");
    },
  },
};
</script>

<style scoped>
.main {
  position: relative;
  width: 100%;
}

.btn-cancel {
  background: white;
  min-width: 100px;
}

.btn-cancel:hover {
  color: grey !important;
}

.btn-save {
  background: #b41bb4;
  color: white !important;
  border: none;
  min-width: 100px;
}

.input {
  display: flex;
}

.input-text {
  margin-right: 10px;
}

.text-description {
  font-size: 11px;
}

.text-error {
  color: red;
  margin: 0;
  font-size: 14px;
}

.footer {
  position: absolute;
  bottom: 0;
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.text-red{
  color: red;
}
</style>
